
  /**
   * @license
   * author: @SFE
   * @sfe/bone-cache v0.0.5
   * Released under the MIT license.
   */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Cookies = require('js-cookie');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Cookies__default = /*#__PURE__*/_interopDefaultLegacy(Cookies);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var hostname = window.location.hostname; // 如果当前是 HTTPS 环境，则默认让 cookie 走安全模式
// 需要看集团默认的状态

if (window.location.protocol === "https:") {
  Cookies__default["default"].withAttributes({
    secure: true
  });
}

var CustomCookies = Object.assign(Cookies__default["default"], {
  /**
   * 删除自身和上级域的 Cookie
   *
   * @param {string} key 名称
   * @param {Object} [options={}] 配置
   * @return {Cookie}
   */
  removeForce: function removeForce(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // 先删除自身
    Cookies__default["default"].remove(key, options); // 尝试删除上级域 Cookie ，删除还行，设置时得操心...
    // www.public-test-1.bybit.com：
    //      public-test-1.bybit.com
    //      bybit.com
    // testnet.bybit.com
    //      bybit.com
    //      com

    Cookies__default["default"].remove(key, _objectSpread2(_objectSpread2({}, options), {}, {
      domain: hostname.split(".").slice(1).join(".")
    }));
    Cookies__default["default"].remove(key, _objectSpread2(_objectSpread2({}, options), {}, {
      domain: hostname.split(".").slice(2).join(".")
    }));
    return this;
  },

  /**
   * 设置 JSON 缓存
   *
   * @param {string} key 缓存名称
   * @param {Object} options 配置参数
   * @return {Object}
   */
  setJSON: function setJSON(key, data, options) {
    try {
      return Cookies__default["default"].set(key, JSON.stringify(data), options);
    } catch (e) {
      return null;
    }
  },

  /**
   * 获取 JSON 缓存
   *
   * @param {string} key 缓存名称
   * @param {Object} options 配置参数
   * @return {Object}
   */
  getJSON: function getJSON(key) {
    try {
      var val = Cookies__default["default"].get(key);
      return JSON.parse(val);
    } catch (e) {
      return null;
    }
  }
});

var CustomStorage = /*#__PURE__*/function () {
  function CustomStorage(_ref) {
    var key = _ref.key;

    _classCallCheck(this, CustomStorage);

    _defineProperty(this, "$key", void 0);

    _defineProperty(this, "engine", void 0);

    this.$key = key;
    this.engine = window[this.$key];
  }
  /**
   * 获取所有缓存
   * @returns {Record<string, unknown>} 所有缓存
   */


  _createClass(CustomStorage, [{
    key: "getAll",
    value: function getAll() {
      var len = this.engine.length; // 获取长度

      var all = {};

      for (var i = 0; i < len; i++) {
        var key = this.engine.key(i);

        if (key) {
          var value = this.engine.getItem(key); // 放进数组

          all[key] = value;
        }
      }

      return all;
    }
    /**
     * 获取缓存
     *
     * @param {string|undefined} key 缓存名称，如果为空则获取全部缓存
     */

  }, {
    key: "get",
    value: function get(key) {
      try {
        return key ? this.engine.getItem(key) : this.getAll();
      } catch (e) {
        return null;
      }
    }
    /**
     * 设置缓存
     *
     * @param {string} key 缓存名称
     * @param {string} value 缓存数据
     */

  }, {
    key: "set",
    value: function set(key, value) {
      try {
        return this.engine.setItem(key, value);
      } catch (e) {
        return undefined;
      }
    }
    /**
     * 删除缓存
     *
     * @param {string} key 缓存名称
     * @return {undefined}
     */

  }, {
    key: "remove",
    value: function remove(key) {
      try {
        return this.engine.removeItem(key);
      } catch (e) {
        return undefined;
      }
    }
    /**
     * 为了兼容 cookie 操作，这里加个别名
     *
     * @param {string} key 缓存名称
     * @return {undefined}
     */

  }, {
    key: "removeForce",
    value: function removeForce(key) {
      return this.remove(key);
    }
    /**
     * 设置 JSON 缓存
     *
     * @param {string} key 缓存名称
     * @param {Object} data 缓存数据
     * @return {undefined}
     */

  }, {
    key: "setJSON",
    value: function setJSON(key, data) {
      return this.set(key, JSON.stringify(data));
    }
    /**
     * 获取 JSON 缓存
     *
     * @param {string} key 缓存名称
     * @return {Object}
     */

  }, {
    key: "getJSON",
    value: function getJSON(key) {
      var val = this.get(key);
      return JSON.parse(val);
    }
  }]);

  return CustomStorage;
}();

var ls = new CustomStorage({
  key: "localStorage"
});

var session = new CustomStorage({
  key: 'sessionStorage'
});

var RAM = /*#__PURE__*/function () {
  function RAM() {
    _classCallCheck(this, RAM);

    _defineProperty(this, "$cache", void 0);

    this.$cache = {};
  }
  /**
   * 获取缓存
   *
   * @param {string|undefined} key 缓存名称，如果为空则获取全部缓存
   * @return {Object|string}
   */


  _createClass(RAM, [{
    key: "get",
    value: function get(key) {
      return key ? this.$cache[key] : this.$cache;
    }
    /**
     * 设置缓存
     *
     * @param {string} key 缓存名称
     * @param {string} value 缓存数据
     * @return {undefined}
     */

  }, {
    key: "set",
    value: function set(key, value) {
      this.$cache[key] = value;
    }
    /**
     * 删除缓存
     *
     * @param {string} key 缓存名称
     * @return {undefined}
     */

  }, {
    key: "remove",
    value: function remove(key) {
      delete this.$cache[key];
    }
    /**
     * 为了兼容 cookie 操作，这里加个别名
     *
     * @param {string} key 缓存名称
     * @return {undefined}
     */

  }, {
    key: "removeForce",
    value: function removeForce(key) {
      return this.remove(key);
    }
    /**
     * 设置 JSON 缓存
     *
     * @param {string} key 缓存名称
     * @param {Object} data 缓存数据
     * @return {undefined}
     */

  }, {
    key: "setJSON",
    value: function setJSON(key, data) {
      return this.set(key, data);
    }
    /**
     * 获取 JSON 缓存
     *
     * @param {string} key 缓存名称
     * @return {Object}
     */

  }, {
    key: "getJSON",
    value: function getJSON(key) {
      return this.get(key);
    }
  }]);

  return RAM;
}();

var ram = new RAM();

var vue = (function (app) {
  app.config.globalProperties.$ls = ls;
  app.config.globalProperties.$cookie = CustomCookies;
  app.config.globalProperties.$session = session;
  app.config.globalProperties.$ram = ram;
});

exports.cookie = CustomCookies;
exports.installVue = vue;
exports.ls = ls;
exports.ram = ram;
exports.session = session;
